angular.module('app').config(billsRouting);

function billsRouting($routeProvider) {
  $routeProvider
    .when('/bills', {
      pageTitle: 'BILLS',
      template: '<bills-page></bills-page>',
      accessPermission: 'index_bill_accountadmin',
      menu: 'purchases',
      authReq: true,
    })
    .when('/bills/new', {
      params: {
        salePersonId: null,
        bookingId: null,
        clientId: null,
        currencyId: null,
      },
      pageTitle: 'ADD_BILL',
      template: '<bill-page></bill-page>',
      breadcrumb: {
        label: 'BILLS',
        parent: 'bills',
        ajs: true,
      },
      accessPermission: 'create_bill_accountadmin',
      menu: 'purchases',
      authReq: true,
    })
    .when('/bills/:id', {
      params: {
        mode: null,
        // fromBooking: null,
      },
      pageTitle: 'BILL',
      template: '<bill-page></bill-page>',
      breadcrumb: {
        label: 'BILLS',
        parent: 'bills',
        ajs: true,
      },
      accessPermission: 'show_bill_accountadmin',
      menu: 'purchases',
      authReq: true,
    });
}

billsRouting.$inject = ['$routeProvider'];
